const UNKNOWN_CURRENCY = '—';

export const getTransactionCurrency = (transaction) => (
  transaction.currency || (transaction.type === 'income'
    ? transaction.to_location_currency
    : transaction.from_location_currency) || UNKNOWN_CURRENCY
);

export const totalsByCurrency = (transactions) => {
  const totals = new Map();
  transactions.forEach((transaction) => {
    const currency = getTransactionCurrency(transaction);
    totals.set(currency, (totals.get(currency) || 0) + Number(transaction.amount || 0));
  });
  return Array.from(totals, ([currency, amount]) => ({ currency, amount }));
};
